<template>
  <div>
    <div class="timo-navbar">
      <div class="container grid-xl">
        <header class="navbar">
          <section class="navbar-section">
          </section>
          <section class="navbar-center">
            <img src="../assets/logo_white.svg" class="timo-logo" alt="Timo Logo">
          </section>
          <section class="navbar-section">
          </section>
        </header>
      </div>
    </div>
    <div class="container grid-sm">
      <div class="columns">
        <div class="column col-12">
          <div class="text-center loader" v-if="loading">
            <img src="./../assets/loader.svg" class="loader"/>
          </div>
          <div v-else-if="noGuru">
            <h1 class="text-center">Guru Doesn't exist</h1>
            <PrimaryButton class="chat-button wide" :click="getAppAndroid" v-if="os == 'Android' || os == 'unknown'">
              Install App on Android
            </PrimaryButton>
            <PrimaryButton class="chat-button wide" :click="getAppIos" v-if="os == 'iOS' || os == 'unknown'">Install App
              on iOS
            </PrimaryButton>
            <PrimaryButton class="chat-button wide" :click="openTimonNoDeep">Open Timon</PrimaryButton>
          </div>
          <div v-else>
            <div class="text-center profile">
              <figure class="avatar avatar-xl">
                <img :src="guru.image" alt="Profile Image"/>
              </figure>
              <div :class="{'panel-title': true, h3: true, 'mt-10': true, 'text-gray': !active}">{{guru.name}}</div>
              <div :class="{'panel-title': true, h4: true, 'mt-10': true, 'text-gray': !active}">
                {{guru.details.title}}
              </div>
              <div :class="{'panel-title': true, h5: true, 'mt-10': true, 'text-gray': !active, 'text-italic': true}">
                {{guru.details.tagline}}
              </div>
              <div :class="{'panel-title': true, h5: true, 'mt-10': true, 'text-gray': !active}">
                {{guru.payment.currencySymbol}} {{(guru.payment.cost / 100).toFixed(2)}}
              </div>
              <EstimatedCurrency :myCurrency="myCurrency"></EstimatedCurrency>
              <div :class="{'panel-title': true, h5: true, 'mt-10': true, 'text-gray': !active}">per {{paymentTime / 2}} min{{paymentTime/2 === 1 ? '': 's'}} of
                voice<br/>Or {{paymentTime}} min{{paymentTime === 1 ? '': 's'}} of text chat
              </div>
              <span><div :class="{'panel-title': true, h5: true, 'mt-10': true, 'text-gray': !active, rating: true}">{{`${(guru.rating.average / 100).toFixed(2)}`}}</div><img
                src="../assets/icons/star.svg" class="star-icon" alt="Star"></span>
              <div v-if="busy">
                <h6>
                  This Timon Guru is super excited to chat to you!
                  To get warmed up for you they're currently bestowing sage advice on a fellow Timon superstar 😉
                  Hold tight and try again in a few minutes. Looking forward to the chat!
                </h6>
              </div>
              <PrimaryButton class="chat-button wide" :click="getAppAndroid" v-if="os == 'Android' || os == 'unknown'">
                Install App on Android
              </PrimaryButton>
              <PrimaryButton class="chat-button wide" :click="getAppIos" v-if="os == 'iOS' || os == 'unknown'">Install
                App on iOS
              </PrimaryButton>
              <PrimaryButton class="chat-button wide" :click="openTimon">Open Timon</PrimaryButton>
            </div>
            <div class="divider"></div>
            <div class="profile-body">
              <div class="h6 mt-10 text-gray" v-if="country">COUNTRY</div>
              <p :class="{'text-gray': !active}" v-if="country">{{countryFlag}}{{country}}</p>
              <div class="h6 mt-10 text-gray">BIO</div>
              <VueMarkdown :class="{'text-gray': !active}" v-if="bio">{{guru.details.bio}}</VueMarkdown>
              <div class="panel-title h6 mt-10 text-gray">VITALS</div>
              <VueMarkdown :class="{'text-gray': !active}" v-if="vitals">{{guru.details.vitals}}</VueMarkdown>
              <div class="panel-title h6 mt-10 text-gray">TOPICS</div>
              <VueMarkdown :class="{'text-gray': !active}" v-if="topics">{{guru.details.topics}}</VueMarkdown>
              <div class="panel-title h6 mt-10 text-gray">TAGS</div>
              <span class="chip" v-for="tag in guru.details.tags"><router-link :to="`/tag/${tag}`">{{tag}}</router-link></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VueMarkdown from 'vue-markdown';
  import PrimaryButton from '@/components/Buttons/Primary';
  import { getGuru } from '@/api';
  import _ from 'lodash';
  import EstimatedCurrency from './EstimatedCurrency';
  import {flag} from 'country-emoji';
  export default {
    name: 'MeProfile',
    data () {
      return {
        loading: false,
        guru: null,
        busy: false,
        noGuru: false
      };
    },
    computed: {
      image () {
        let image = this.guru ? this.guru.image : '';
        if (image.includes('images.timonapp.com')) {
          return image + '?' + (new Date()).getTime();
        } else {
          return image;
        }
      },
      id () {
        return this.guru ? this.guru.user : '';
      },
      active () {
        return this.guru ? this.guru.active : '';
      },
      name () {
        return this.guru ? this.guru.name : '';
      },
      vitals () {
        return this.guru ? this.guru.details.vitals : '';
      },
      tagline () {
        return this.guru ? this.guru.details.tagline : '';
      },
      title () {
        return this.guru ? this.guru.details.title : '';
      },
      bio () {
        return this.guru ? this.guru.details.bio : '';
      },
      topics () {
        return this.guru ? this.guru.details.topics : '';
      },
      tags () {
        return this.guru ? this.guru.details.tags : '';
      },
      rating () {
        return this.guru ? this.guru.rating : '';
      },
      paymentCost () {
        return ((this.guru ? this.guru.payment.cost : 0) / 100).toFixed(2);
      },
      paymentSymbol () {
        return this.guru ? this.guru.payment.currencySymbol : '';
      },
      paymentTime () {
        return (this.guru ? this.guru.payment.time : 0) / 60;
      },
      guruBusy () {
        return this.busy;
      },
      os () {
        return getMobileOperatingSystem();
      },
      myCurrency () {
        return _.get(this.guru, 'payment.myCurrency', '');
      },
      country () {
        return this.guru.country
      },
      countryFlag () {
        return flag(this.country);
      },
    },
    methods: {
      getAppAndroid () {
        window.open('https://play.google.com/store/apps/details?id=com.timonapp&hl=en');
      },
      getAppIos () {
        window.open('https://itunes.apple.com/us/app/timon/id1330012900?mt=8');
      },
      async loadGuru () {
        this.loading = true;
        let data = await getGuru(this.$route.params.id);
        if (data.error) {
          this.noGuru = true;
          this.loading = false;
          return 0;
        }
        this.guru = data.guru;
        this.busy = data.busy;
        this.loading = false;
      },
      openTimon () {
        if (this.os === 'unknown') {
          window.open(process.env.BACK_URL + this.$route.params.id);
        } else {
          window.open('com.timonapp://guru/' + this.$route.params.id);
        }
      },
      openTimonNoDeep () {
        if (this.os === 'unknown') {
          window.open(process.env.BACK_URL.replace('/guru/', ''));
        } else {
          window.open('com.timonapp://');
        }
      }
    },
    created () {
      this.loadGuru();
    },
    mounted () {
      window.scrollTo(0, 0);
    },
    components: {
      VueMarkdown,
      PrimaryButton,
      EstimatedCurrency
    }
  };

  function getMobileOperatingSystem () {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains 'Android'
    /* if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone'
    } */

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }

    return 'unknown';
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .timo-navbar {
    background: linear-gradient(to right, #83C566, #5DE9B1);;
  }

  .timo-navbar .timo-logo {
    height: 70px;
    margin-top: 40px;
    margin-bottom: 40px;
  }

  .profile {
    padding-top: 20px;
  }

  .avatar img {
    margin-bottom: 10px;
    border-width: 5px;
    border-style: solid;
    border-color: #79CC57;
  }

  .avatar {
    margin-bottom: 10px;
  }

  .star-icon {
    height: 1rem
  }

  .profile-body {
    padding-left: 20px;
    padding-right: 20px;
  }

  h6 {
    padding-top: 10px;
    font-family: sans-serif;
    font-size: 20px;
    color: #B3B3B3;
  }

  .accordion {
    margin-top: 20px;
  }

  .chat-button {
    margin: 10px 0 10px 0;
  }

  .form-input {
    border-radius: 2px !important;
  }

  .form-input:focus {
    border-color: #18bc9c !important;
    -webkit-box-shadow: 0 0 0 0.2rem rgba(131, 197, 102, .15) !important;
  }

  .rating {
    display: inline-block;
    margin-bottom: 0px;
    vertical-align: middle
  }

  .star-icon {
    display: inline-block;
    height: 20px;
    vertical-align: middle;
    margin-left: 5px;
  }

  .loader {
    margin-top: 5px;
    height: 20px;
  }

  .accordion-header {
    border-width: 1px;
    border-style: solid;
  }

  .accordion-header:hover {
    border-color: #18bc9c !important;
    -webkit-box-shadow: 0 0 0 0.2rem rgba(131, 197, 102, .15) !important;
  }

  .share-icon {
    height: 30px;
    margin: 10px;
    cursor: pointer;
  }

  .share-button {
    float: right;
    margin-top: -60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Guru.vue